import React from "react";
import { Select } from "@windmill/react-ui";
const EndTimePicker = ({
  EndTimeOptions,
  handleEndTimeChange,
  register,
  name,
  label,
  selectedEndTime,
}) => {
  return (
    <>
      <Select
        className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
        {...register(`${name}`, {
          required: !selectedEndTime ? `${label} is required!` : false,
        })}
        name={name}
        value={selectedEndTime}
        onChange={(e) => handleEndTimeChange(e)}
      >
        {EndTimeOptions?.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </Select>
    </>
  );
};

export default EndTimePicker;
